import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface LogoProps extends BoxProps {
  height?: number;
  width?: string | number;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ height = 48, width = 'auto', color = '#10B981', ...props }) => {
  return (
    <Box
      component="img"
      src="/logo.svg"
      alt="Social Media AI Agent Logo"
      sx={{
        height: height,
        width: width,
        filter: color !== '#10B981' ? `brightness(0) saturate(100%) invert(1)` : 'none',
        ...props.sx,
      }}
      {...props}
    />
  );
};

export default Logo;
